import React, { useState } from 'react';
import { Input, Modal, Select, Space, message } from 'antd';
import * as api from '../api/client';

interface Props {
  open: boolean;
  userId?: string;
  onCancel: () => void;
  onCreated: (kb: { id: string; name: string }) => void;
}

const splitTags = (value: string): string[] =>
  value.split(',').map(v => v.trim()).filter(Boolean);

const KnowledgeBaseCreateModal: React.FC<Props> = ({ open, onCancel, onCreated, userId = '' }) => {
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [visibility, setVisibility] = useState<'private' | 'workspace'>('private');
  const [tags, setTags] = useState('');
  const [saving, setSaving] = useState(false);

  const reset = () => {
    setName('');
    setDescription('');
    setVisibility('private');
    setTags('');
  };

  const handleSubmit = async () => {
    if (!name.trim()) {
      message.warning('Knowledge base name is required');
      return;
    }
    setSaving(true);
    try {
      const res = await api.createKnowledgeBaseAlias({
        name: name.trim(),
        description: description.trim(),
        visibility,
        tags: splitTags(tags),
        user_id: userId,
      });
      const kb = res.data;
      onCreated({ id: kb.id, name: kb.name });
      message.success('Knowledge base created');
      reset();
    } catch {
      message.error('Failed to create knowledge base');
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal
      open={open}
      title="Create New Knowledge Base"
      onCancel={() => { reset(); onCancel(); }}
      onOk={handleSubmit}
      okText="Create"
      confirmLoading={saving}
    >
      <Space direction="vertical" style={{ width: '100%' }}>
        <Input placeholder="KB name" value={name} onChange={(e) => setName(e.target.value)} />
        <Input.TextArea
          placeholder="Description"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          rows={3}
        />
        <Select
          value={visibility}
          onChange={(next) => setVisibility(next)}
          options={[
            { value: 'private', label: 'Private' },
            { value: 'workspace', label: 'Workspace' },
          ]}
        />
        <Input placeholder="Tags (comma separated)" value={tags} onChange={(e) => setTags(e.target.value)} />
      </Space>
    </Modal>
  );
};

export default KnowledgeBaseCreateModal;
